import React, { Fragment } from 'react';
import { Text } from '@gasbuddy/react-components';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import styles from './PaymentOptions.module.css';
import { SpendLimitsPropType } from '../../prop-types/spend-limits';

const cx = classnames.bind(styles);

const MembershipBenefits = ({ spendLimits }) => (
  <Text className={cx('benefits')} as="p">
    <strong>20¢/gal guaranteed</strong> and <strong>22¢/gal</strong> at select stations (up to 50 gallons per month), and 5¢/gal thereafter.<br />
    Spend $25 in-store, <strong>earn an extra 3¢/gal</strong><br />
    <strong>{spendLimits.daily_limit} daily</strong> spending limit<br />
    {!!spendLimits.pump_limit && (
      <Fragment>
        <strong>{spendLimits.pump_limit} pump</strong> transaction limit<br />
      </Fragment>
    )}
    <strong>{spendLimits.weekly_limit} weekly</strong> spending limit<br />
    Automatically pay your card balance
  </Text>
);
MembershipBenefits.propTypes = {
  spendLimits: SpendLimitsPropType.isRequired,
};

const RegularBenefits = ({ spendLimits }) => (
  <Text className={cx('benefits')} as="p">
    <strong>3¢/gal savings</strong> on every fill-up<br />
    <strong>5¢/gal savings</strong> at select stations<br />
    Spend $25 in-store, <strong>earn an extra 3¢/gal</strong><br />
    <strong>{spendLimits.daily_limit} daily</strong> spending limit<br />
    {!!spendLimits.pump_limit && (
      <Fragment>
        <strong>{spendLimits.pump_limit} pump</strong> transaction limit<br />
      </Fragment>
    )}
    <strong>{spendLimits.weekly_limit} weekly</strong> spending limit<br />
    Automatically pay your card balance
  </Text>
);
RegularBenefits.propTypes = {
  spendLimits: SpendLimitsPropType.isRequired,
};

export default function AutopayPaymentOption({
  isMembershipUser,
  interactive,
  spendLimits,
}) {
  return (
    <React.Fragment>
      <Text className={cx('label')}>Auto Pay</Text>
      {isMembershipUser ? <MembershipBenefits spendLimits={spendLimits} /> : <RegularBenefits spendLimits={spendLimits} />}
      {interactive && (
        <Text as="span" className={cx('pill')}>
          <FontAwesomeIcon
            icon={faCheck}
            size="1x"
          />
          &nbsp;
          Recommended
        </Text>
      )}
    </React.Fragment>
  );
}

AutopayPaymentOption.propTypes = {
  spendLimits: SpendLimitsPropType.isRequired,
  isMembershipUser: PropTypes.bool,
  interactive: PropTypes.bool,
};

AutopayPaymentOption.defaultProps = {
  isMembershipUser: false,
  interactive: false,
};
